import { PermissionValue } from "../public-api";

export interface Country {
  country_code: string;
  country_name: string;
  id: string;
}

export interface Industry {
  id: string;
  type: string;
}

export interface RolesList {
  role_id: string;
  role_name: string;
}

export interface ManagerList {
  user_id: string;
  usr_name: string;
}

export interface MenuItems {
  name: string;
  path: string;
  iconurl: string;
  viewCondition: boolean;
  children?: MenuChild[];
}

export interface MenuChild {
  name: string;
  path: string;
  iconurl?: string;
  viewCondition: boolean;
}

export interface NotificationDetail {
  datetime: SVGStringList;
  notification_datetime: Date | string;
  notification_message: string;
  notification_type: string;
  receiver_firstname: string;
  receiver_lastname: string;
  sender_firstname: string;
  sender_id: string;
  profile_picture: string;
  sender_lastname: string;
  notification_id: string;
}